export type Platform = 'ios' | 'android' | 'other';

/**
 * Detect the mobile OS from a user agent string.
 *
 * Android is checked first: Android user agents contain "Linux" and never
 * contain "iPhone", so a first-match-wins order is safe.
 *
 * iPadOS 13+ reports a desktop Safari user agent containing "Macintosh", which
 * is indistinguishable from a real Mac by user agent alone. The touch point
 * count is the tiebreaker: iPads report 5, Macs report 0.
 */
export function detectPlatform(userAgent: string, maxTouchPoints: number): Platform {
  if (/Android/i.test(userAgent)) {
    return 'android';
  }

  if (/iPhone|iPad|iPod/i.test(userAgent)) {
    return 'ios';
  }

  if (/Macintosh/i.test(userAgent) && maxTouchPoints > 1) {
    return 'ios';
  }

  return 'other';
}
